module.exports = __webpack_public_path__ + "img/congress.9dd7a81c.webp";